class eSignatureFunctions {
    /*
    {
        sigContainerElemId: string !!required
        formContainerElemId: string !!required
        sigInputId: string !!required
        domIdPrefix: string
        destructOnSubmit: bool
        submitCallback: () => {}			

    }
    */
    constructor(config) {
        if (!config || !config.sigContainerElemId || !config.formContainerElemId || !config.sigInputId) {
            throw new Error(`${this.constructor.name} requires a config object which defines at least signature container ID, form container ID and signature form input ID!`);
        }
        this.config = config;
        this.sigContainerElemId = this.config.sigContainerElemId;
        this.formContainerElemId = this.config.formContainerElemId;
        this.domIdPrefix = this.config.domIdPrefix || 'sig-';
        this.destructOnSubmit = this.config.destructOnSubmit || true; 
        this.canvasMaxWidth = 620;
        this.canvasMaxHeight = 350;
        this.lineColor = "#424242";
        this.lineWidth = 2;
        this.shadowLineWidth = 1;

        this.canvas = document.getElementById(`${this.domIdPrefix}canvas`);
        this.canvasCtx = this.canvas.getContext("2d");

        this.originalWidth = this.canvas.width;
        this.originalHeight = this.canvas.height;
        this.scrollPosition = undefined;
        this.drawing = false;
        this.ctxImageData = undefined;
        this.mousePos = {
            x: 0,
            y: 0
        };
        this.lastPos = this.mousePos;

        this.sigText = document.getElementById(`${this.domIdPrefix}dataUrl`);
        this.sigImage = document.getElementById(`${this.domIdPrefix}image`);
        this.clearBtn = document.getElementById(`${this.domIdPrefix}clear`);
        this.submitBtn = document.getElementById(`${this.domIdPrefix}submit`);

        this.submitBtn.disabled = true;
        this.clearBtn.disabled = true;

        // draw events
        $(this.canvas).on("mousedown.esignature", (e) => {
            e.preventDefault();
            this.drawNow(true);
            this.mousePos = this.getMousePos(this.canvas, e);
            this.lastPos = Object.assign({}, this.mousePos);
        });

        $(this.canvas).on("mouseup.esignature", (e) => {
            e.preventDefault();
            this.drawNow(false);
        });

        $(this.canvas).on("mousemove.esignature", (e) => {
            e.preventDefault();
            if (this.drawing) {
                this.mousePos = this.getMousePos(this.canvas, e);
                this.renderCanvas();
            }
        });

        // Add touch event support for mobile

        $(this.canvas).on("touchstart.esignature", (e) => {
            e.preventDefault();
            this.drawNow(true);
            this.mousePos = this.getTouchPos(this.canvas, e);
            this.lastPos = Object.assign({}, this.mousePos);
        });

        $(this.canvas).on("touchend.esignature", (e) => {
            e.preventDefault();
            this.drawNow(false);
        });

        $(this.canvas).on("touchcancle.esignature", (e) => {
            e.preventDefault();
            this.drawNow(false);
        });

        $(this.canvas).on("touchmove.esignature", (e) => {
            e.preventDefault();
            this.mousePos = this.getTouchPos(this.canvas, e);
            this.renderCanvas();
        });

        $(this.canvas).on("mouseleave.esignature", (e) => {
            e.preventDefault();
            this.drawNow(false);
        });

        // UI events
        $(this.clearBtn).on('click.esignature', (e) => {
            e.preventDefault();
            this.clearCanvas();
            // this.sigText.innerHTML = 'Signatur wird hier angezeigt';
            // this.sigImage.setAttribute('src', '');
            //document.getElementById(`${this.domIdPrefix}data`).style.display = 'none';
        });
        document.getElementById(`${this.domIdPrefix}data`).style.display = 'none';

        $(this.submitBtn).on('click.esignature', (e) => {
            e.preventDefault();
            document.getElementById(this.config.sigInputId).value = this.canvas.toDataURL();
            // this.sigImage.setAttribute('src', dataUrl);
            // document.querySelector('#sig-data').style.display = 'block';
            this.clearCanvas();

            document.getElementById(this.sigContainerElemId).classList.add('hidden');
            document.getElementById(this.formContainerElemId).classList.remove('hidden');

            if(this.destructOnSubmit){
                // remove all event handlers
                $(this.canvas).off("mousedown.esignature");
                $(this.canvas).off("mouseup.esignature");
                $(this.canvas).off("mousemove.esignature");

                $(this.canvas).off("touchstart.esignature");
                $(this.canvas).off("touchend.esignature");
                $(this.canvas).off("touchcancle.esignature");
                $(this.canvas).off("touchmove.esignature");

                $(this.canvas).off("mouseleave.esignature");

                $(this.clearBtn).off('click.esignature');
                $(this.submitBtn).off('click.esignature');

                $(window).off('resize.esignature');
                this.enableScroll();
            }

            if (typeof this.config.submitCallback === 'function') {
                this.config.submitCallback();
            }

        });

        
        $(window).on('resize.esignature', () => {
            this.resizeCanvas();
        });

        this.resizeCanvas();
    };

    disableScroll() {
        this.scrollPosition = window.scrollY;
        $(window).on("scroll.esignature", (e) => {
            if ( this.drawing && typeof this.scrollPosition != 'undefined' ) {
                window.scrollTo(0, this.scrollPosition);
            }
        });
    };

    enableScroll() {
        $(window).off('scroll.esignature');
    };

    drawNow(drawActive){
        if (this.drawing !== drawActive) {
            this.drawing = drawActive;
            if (this.drawing) {
                document.getElementById(`${this.domIdPrefix}data`).style.display = 'none';
                this.clearBtn.disabled = false;
                this.submitBtn.disabled = false;
                // IMPORTANT: 
                // disable the "pull down" reload gesture on mobile devices while drawing
                //document.body.style['overscroll-behavior'] = 'contain';
                //document.body.style.overflow = "hidden";
                this.disableScroll();
            } else {
                //document.body.style['overscroll-behavior'] = null;
                //document.body.style.overflow = "auto";
                this.enableScroll();
            }
        }
    };

    getMousePos(canvasDom, mouseEvent) {
        const rect = canvasDom.getBoundingClientRect();
        return {
            x: (mouseEvent.clientX - rect.left),
            y: (mouseEvent.clientY - rect.top)
        };
    };

    getTouchPos(canvasDom, touchEvent) {
        const ratio = Math.max(window.devicePixelRatio || 1, 1);
        const rect = canvasDom.getBoundingClientRect();

        return {
            x: Math.round(touchEvent.touches[0].clientX - rect.left),
            y: Math.round(touchEvent.touches[0].clientY - rect.top)
        };
    }

    // render
    
    renderCanvas() {
        if (this.drawing) {
            this.canvasCtx.beginPath();
            this.canvasCtx.moveTo(this.lastPos.x, this.lastPos.y);
            this.canvasCtx.lineTo(this.mousePos.x, this.mousePos.y);
            this.canvasCtx.stroke();
            this.lastPos = this.mousePos;
            let canvasRect = this.canvas.getBoundingClientRect();
            this.ctxImageData = this.canvasCtx.getImageData(0, 0, canvasRect.width, canvasRect.height);
        }
    };

    _resizeCanvas() {
        const ratio = Math.max(window.devicePixelRatio || 1, 1);

        var winHeight = window.innerHeight;
//console.log('winHeight', winHeight)
        var btnRect = document.getElementById(`${this.domIdPrefix}submit`).getBoundingClientRect();
        var canvasRect = document.getElementById(`${this.domIdPrefix}canvas`).getBoundingClientRect();
        var canvasNewHeight = this.canvasMaxHeight;
        if (canvasRect.top + canvasNewHeight + btnRect.height * ratio > winHeight) {
            var sigContRect = document.getElementById(this.sigContainerElemId).getBoundingClientRect();
            canvasNewHeight = Math.min(this.canvasMaxHeight, sigContRect.height - btnRect.height);
        }
//console.log('canvasNewHeight', canvasNewHeight)            

        this.canvas.width = (this.canvas.offsetWidth * ratio);
        this.canvas.height = ((canvasNewHeight - 30) * ratio);
        this.canvasCtx.scale(ratio, ratio);
        this.canvasCtx.strokeStyle = this.lineColor;
        this.canvasCtx.shadowColor = this.lineColor;
        this.canvasCtx.shadowBlur = this.shadowLineWidth;
        this.canvasCtx.lineWidth = this.lineWidth;
    };

    resizeCanvas() {
        let container = this.canvas.parentElement;

        const containerWidth = container.offsetWidth;
        const containerHeight = window.visualViewport.height;

        const aspectRatio = this.originalWidth / this.originalHeight;
        let newWidth, newHeight;

        if (containerWidth / containerHeight > aspectRatio) {
            // Container is wider relative to its height
            newHeight = containerHeight * 0.8; // Adjusted for padding
            newWidth = newHeight * aspectRatio;
        } else {
            // Container is taller relative to its width
            newWidth = containerWidth * 0.9; // Adjusted for padding
            newHeight = newWidth / aspectRatio;
        }

        // Ensure that the canvas fits within the container
        var btnRect = document.getElementById(`${this.domIdPrefix}submit`).getBoundingClientRect();
        var canvasRect = document.getElementById(`${this.domIdPrefix}canvas`).getBoundingClientRect();
        if (canvasRect.top + newHeight + btnRect.height > window.innerHeight) {
            var sigContRect = document.getElementById(this.sigContainerElemId).getBoundingClientRect();
            newHeight = Math.min(this.canvasMaxHeight, sigContRect.height - btnRect.height);
            newWidth = newHeight * aspectRatio;
        }

        this.canvas.width = newWidth;
        this.canvas.height = newHeight;

        if (typeof this.ctxImageData !== 'undefined') {
            this.putImage(this.ctxImageData);
        }
    }

    putImage(ctxImageData) {
        const canvasWidth = this.canvas.width = this.canvas.clientWidth;
        const canvasHeight = this.canvas.height = this.canvas.clientHeight;

        const imageAspectRatio = ctxImageData.width / ctxImageData.height;
        const canvasAspectRatio = canvasWidth / canvasHeight;

        let drawWidth, drawHeight;
        if (canvasAspectRatio > imageAspectRatio) {
            // Canvas is wider relative to its height than the image
            drawHeight = canvasHeight;
            drawWidth = canvasHeight * imageAspectRatio;
        } else {
            // Canvas is taller relative to its width than the image
            drawWidth = canvasWidth;
            drawHeight = canvasWidth / imageAspectRatio;
        }

        const offsetX = (canvasWidth - drawWidth) / 2;
        const offsetY = (canvasHeight - drawHeight) / 2;

        this.canvasCtx.clearRect(0, 0, this.canvas.width, this.canvas.height);
        this.canvasCtx.putImageData(ctxImageData, offsetX, offsetY, 0, 0, ctxImageData.width, ctxImageData.height);
    };

    clearCanvas() {
        this.submitBtn.disabled = true;
        this.clearBtn.disabled = true;
        this.canvasCtx.clearRect(0, 0, this.canvas.width, this.canvas.height);
        this.ctxImageData = undefined;
    };
}

//export {eSignatureFunctions};